import React from "react";
import "./Checkout.css";
import ad from "./Assets/ad.PNG";
import protection from "./Assets/protection.png";
import Subtotal from "./Subtotal";
import CheckoutProduct from "./CheckoutProduct";
import { useStateValue } from "./StateProvider";
function Checkout() {
  const [state, dispatch] = useStateValue();

  return (
    <div className="checkout">
      <div className="Checkout_left">
        <img className="checkout_ad" src={ad}></img>
        <div>
          <h2 className="checkout_title">Your Shopping Cart</h2>
        </div>
        <div>
          {state.basket.map((val) => {
            return <CheckoutProduct details={val}></CheckoutProduct>;
          })}
        </div>
      </div>
      <div className="checkout_right">
        <img className="checkout_right_protection" src={protection}></img>
        <Subtotal></Subtotal>
      </div>
    </div>
  );
}

export default Checkout;
